export const SET_MODULES = (state, payload) => {
    state.modules = payload;
};
export const SET_QUESTIONS = (state, payload) => {
    state.questions = payload;
};
export const SET_CHOICES = (state, payload) => {
    state.choices = payload;
};
export const SET_QUESTIONNAIRE = (state, payload) => {
    state.questionnaire = payload;
};
export const SET_ABOUT_US = (state, payload) => {
    state.aboutUs = payload;
};
export const SET_PRIVACY_POLICY = (state, privacyPolicy) => {
    state.privacyPolicy = privacyPolicy;
};
export const SET_SLOGANS = (state, payload) => {
    state.slogans = payload;
};
export const SET_AWARDS = (state, payload) => {
    state.awards = payload;
};

export const SET_USER = (state, user) => {
    state.user = user;
}